import Button from './Button';
import { ButtonProps, ButtonValueProps } from './types';

export type { ButtonProps, ButtonValueProps };
export default Button;
